export var TransactionProvider;
(function (TransactionProvider) {
    TransactionProvider["ACH_DWOLLA"] = "bank_ach_dwolla";
    TransactionProvider["INTERNATIONAL_CURRENCYCLOUD"] = "bank_international_currencycloud";
    TransactionProvider["INTERNATIONAL_CONVERA"] = "bank_international_convera";
    TransactionProvider["CHECK_CHECKISSUING"] = "bank_check_checkissuing";
})(TransactionProvider || (TransactionProvider = {}));
